import { IPromise } from 'angular';
import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { KnownOpenApiPartnerAvailabilityDTO } from '@root/manager-base/data/dtos/known-open-api-partner-availability.dto';
import { MarketplaceFormDataDTO } from '@root/app/marketplace/data/dto/marketplace-form-data.dto';
import { KnownOpenApipartnerFormDataRequestDTO } from '@root/manager-base/data/dtos/known-open-api-partner-form-data-request.dto';
import { SaveKnownOpenApiPartnerFormDataRequestDTO } from '@root/manager-base/data/dtos/save-known-open-api-partner-form-data-request.dto';

const actions = {
    getKnownOpenApiPartnerAvailabilities: {
        method: 'GET',
        url: `${BASE_PATH_API}/knownopenapipartners/availability`
    },
    createKnownOpenApiPartnerInstallation: {
        method: 'POST',
        url: `${BASE_PATH_API}/knownopenapipartners/installations`
    },
    getFormData: {
        method: 'GET',
        url: `${BASE_PATH_API}/knownopenapipartners/formdata`
    },
    getFormDataValues: {
        method: 'GET',
        url: `${BASE_PATH_API}/knownopenapipartners/formdata/values`
    },
    saveFormDataValues: {
        method: 'PUT',
        url: `${BASE_PATH_API}/knownopenapipartners/formdata/values`
    }
};

export interface IKnownOpenApiPartnersApi {
    getKnownOpenApiPartnerAvailabilities(searchParams: any): IPromise<KnownOpenApiPartnerAvailabilityDTO[]>;
    createKnownOpenApiPartnerInstallation(request: any): IPromise<any>;
    getFormData(request: KnownOpenApipartnerFormDataRequestDTO): IPromise<MarketplaceFormDataDTO>;
    getFormDataValues(request: KnownOpenApipartnerFormDataRequestDTO): IPromise<any>
    saveFormDataValues(request: SaveKnownOpenApiPartnerFormDataRequestDTO): IPromise<void>
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function KnownOpenApiPartnersApi(): IKnownOpenApiPartnersApi {
    return createActions(actions);
}
